export default function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function")
        throw new TypeError("values is not iterable");
    if (typeof mapper !== "function")
        throw new TypeError("mapper is not a function");
    return Array.from(values, function (value, index) { return mapper(value, index, values); });
}
